export enum VentureNoteTypeModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
